
import { useEffect } from 'react';

interface StructuredDataProps {
  type: 'LocalBusiness' | 'WebPage' | 'Article' | 'Service' | 'FAQPage';
  data: any;
}

const StructuredData = ({ type, data }: StructuredDataProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';

    let structuredData;

    switch (type) {
      case 'LocalBusiness':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "CashFlow VIP",
          "description": "Especialistas en reestructuración de crédito y acceso a capital sin intereses",
          "url": import.meta.env.VITE_SITE_URL || "https://example.com",
          "telephone": "+13056840894",
          "email": "info@cashflow.vip",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "936 71st St",
            "addressLocality": "Miami Beach",
            "addressRegion": "FL",
            "postalCode": "33141",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 25.7617,
            "longitude": -80.1918
          },
          "openingHours": [
            "Mo-Fr 09:00-19:00",
            "Sa 10:00-16:00"
          ],
          "sameAs": [
            "https://www.instagram.com/fiormartecpa/",
            "https://www.skool.com/cashflow"
          ],
          "logo": "/Logo_Cashflow_VIP.svg",
          "image": "/Logo_Cashflow_VIP.svg",
          "priceRange": "$$",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "500"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Servicios Financieros",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Reparación de Crédito",
                  "description": "Incrementa tu score crediticio y elimina elementos negativos"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Creación de Corporaciones",
                  "description": "Formación de LLC y Corporaciones con protección de activos"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Obtención de Funding",
                  "description": "Acceso a capital desde $10K hasta $10M+ para hacer crecer tu negocio"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Mentorías Personalizadas",
                  "description": "Acceso directo a expertos para transformar tu negocio"
                }
              }
            ]
          }
        };
        break;

      case 'WebPage':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": data.title,
          "description": data.description,
          "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}${data.path}`,
          "inLanguage": "es",
          "isPartOf": {
            "@type": "WebSite",
            "name": "CashFlow VIP",
            "url": import.meta.env.VITE_SITE_URL || "https://example.com"
          },
          "about": {
            "@type": "Organization",
            "name": "CashFlow VIP"
          },
          "lastReviewed": "2024-11-14",
          "reviewedBy": {
            "@type": "Organization",
            "name": "CashFlow VIP"
          }
        };
        break;

      case 'Service':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "Service",
          "name": data.name,
          "description": data.description,
          "provider": {
            "@type": "LocalBusiness",
            "name": "CashFlow VIP",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "936 71st St",
              "addressLocality": "Miami Beach",
              "addressRegion": "FL",
              "postalCode": "33141",
              "addressCountry": "US"
            }
          },
          "areaServed": {
            "@type": "Country",
            "name": "United States"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": data.name,
            "itemListElement": data.features?.map((feature: string, index: number) => ({
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": feature
              }
            })) || []
          }
        };
        break;

      case 'FAQPage':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": data.faqs?.map((faq: any) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          })) || []
        };
        break;

      default:
        structuredData = data;
    }

    script.innerHTML = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [type, data]);

  return null;
};

export default StructuredData;
